import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Plus', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M14.1558095,14.0875513 L33.928882,33.9124247",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(24.042346, 23.999988) rotate(45.000000) translate(-24.042346, -23.999988)"
  }), React.createElement("path", {
    d: "M33.8994949,14.1005051 L14.1005051,33.8994949",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "\n                            translate(24.000000, 24.000000) rotate(-135.000000) translate(-24.000000, -24.000000)\n                        "
  }))));
});